/** Poll an async fetch on an interval; returns an unsubscribe like Firestore onSnapshot. */
export function createPollingSubscription(
  fetchFn: () => Promise<void>,
  intervalMs: number = 30_000
): () => void {
  let cancelled = false;

  const run = async () => {
    if (cancelled) return;
    try {
      await fetchFn();
    } catch {
      // Caller handles errors inside fetchFn (e.g. onError callback).
    }
  };

  void run();
  const timer = window.setInterval(run, intervalMs);

  return () => {
    cancelled = true;
    window.clearInterval(timer);
  };
}
